import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import { AsVo } from "src/vo/asVo";
import HomeBgItem from "./HomeBgItem";
import moment from "moment";
import StatusTag from "../common/StatusTag";
import SVG from "src/utils/SVG";

const CompleteItem = () => {
  const [isCompleted, setIsCompleted] = useState(true);

  const completeList: any = useAppSelector((state) => state.homeReduce.completeDataList);

  useEffect(() => {
    return () => {
      const path = location.pathname;
      if (path !== "/home") {
        window.sessionStorage.setItem("homeTab", "2");
      }
    };
  });

  useEffect(() => {
    if (completeList) {
      if (completeList.data.length > 0) {
        setIsCompleted(true);
      } else {
        setIsCompleted(false);
      }
    }
  }, [completeList]);

  return (
    <>
      {isCompleted ? (
        <>
          {completeList?.data.map((info: AsVo, idx: any) => (
            <HomeBgItem key={idx} type="renewal" color="white">
              <Link to={"/as-detail/" + info.as_idx}>
                <div className="renewal-box">
                  <div>
                    <p className="title">{info.category_name}</p>
                    <p className="text">
                      {info.copy_yn === "Y" ? <span className="copy-com">{info.company_name}</span> : ""}
                      {info.contents}
                    </p>
                  </div>
                  <div className="sub-info">
                    <span className="shop-type">{info.store_type_name}</span>
                    <span className="shop-name">
                      {info.store_name}
                      {info.new_yn === "Y" ? <SVG name="new" width={10} height={16} viewBox="0 0 10 16" /> : ""}
                    </span>
                    <p className="date">{info.insert_date ? moment(info.insert_date).format("YYYY.MM.DD") : "-"}</p>
                  </div>
                </div>
              </Link>
            </HomeBgItem>
          ))}
        </>
      ) : (
        <HomeBgItem noItem>
          <p className="noData">확인할 완료보고가 없습니다.</p>
        </HomeBgItem>
      )}
    </>
  );
};

export default CompleteItem;
